import { render, staticRenderFns } from "./InsertFile.vue?vue&type=template&id=553b258a"
import script from "./InsertFile.vue?vue&type=script&lang=js"
export * from "./InsertFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports